import { gql } from "@apollo/client";

export const SIZE_AND_WEIGHT_SEARCH_QUERY = gql`
  query SIZE_AND_WEIGHT_SEARCH_QUERY(
    $perPage: Int
    $page: Int
    $json: String
    $originatorId: ID!
  ) {
    searchSizeAndWeights(
      perPage: $perPage
      page: $page
      json: $json
      originatorId: $originatorId
    ) {
      id
      startedAt
      endedAt
      dimensionViolationIdentified
      weightMethods {
        id
        name
      }
      incident {
        id
        incidentNumber
        locked
        sealed
        officerIncidentSpecifics {
          id
          primaryOfficer
          officer {
            id
            personalAttribute {
              id
              firstName
              lastName
            }
            deptAttribute {
              id
              ori {
                abbreviation
              }
              badge
            }
          }
        }
        incidentTickets {
          id
          ticketNumber
          ticketViolationPrototype {
            id
            name
            fullName
            name
            civilViolation
            municipalOrdinance
            speedingVio
            doNotSubmit
            title
            statute
            section
            code
            ticketCategory {
              id
              name
            }
            ticketEntry {
              name
            }
            waiver
          }
        }
      }
    }
  }
`;
